import { render, staticRenderFns } from "./RadioSelectScore.vue?vue&type=template&id=6fadb87a&scoped=true&"
import script from "./RadioSelectScore.vue?vue&type=script&lang=js&"
export * from "./RadioSelectScore.vue?vue&type=script&lang=js&"
import style0 from "./RadioSelectScore.vue?vue&type=style&index=0&id=6fadb87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fadb87a",
  null
  
)

export default component.exports